/**
 * 多语言（i18n）入口
 * 用途：注册中文 / 英文 / 西班牙语，并持久化用户选择到 localStorage
 * 用法：
 *   1. main.js 中 app.use(i18n)
 *   2. 组件内 const { t, locale } = useI18n()，用 t('home.title') 取文案
 *   3. 切换语言调用 setLocale('en' | 'zh-CN' | 'es')
 */
import { createI18n } from 'vue-i18n'
import zhCN from './locales/zh-CN'
import en from './locales/en'
import es from './locales/es'

/** localStorage 键名：记住用户上次选择的语言 */
export const LOCALE_STORAGE_KEY = 'duogu_locale'

/** 支持的语言列表（导航语言切换器用） */
export const SUPPORTED_LOCALES = [
  { code: 'zh-CN', labelKey: 'lang.zh' },
  { code: 'en', labelKey: 'lang.en' },
  { code: 'es', labelKey: 'lang.es' }
]

/**
 * 读取初始语言
 * 优先级：localStorage（用户曾手动切换）> 默认西班牙语
 */
function getInitialLocale() {
  const saved = localStorage.getItem(LOCALE_STORAGE_KEY)
  if (saved && ['zh-CN', 'en', 'es'].includes(saved)) {
    return saved
  }
  return 'es'
}

const i18n = createI18n({
  legacy: false, // Composition API 模式
  locale: getInitialLocale(),
  fallbackLocale: 'es',
  messages: {
    'zh-CN': zhCN,
    en,
    es
  }
})

/**
 * 切换语言并写入本地缓存
 * 用法：setLocale('en')
 */
export function setLocale(locale) {
  if (!['zh-CN', 'en', 'es'].includes(locale)) return
  i18n.global.locale.value = locale
  localStorage.setItem(LOCALE_STORAGE_KEY, locale)
  document.documentElement.lang = locale === 'zh-CN' ? 'zh-CN' : locale
}

// 初始化 html lang 属性
document.documentElement.lang =
  i18n.global.locale.value === 'zh-CN' ? 'zh-CN' : i18n.global.locale.value

export default i18n
